module.exports = __webpack_public_path__ + "img/newsletter-side.cea47c4.png";